<!--
 * 主页
 *
 -->
<template>
  <div name="Home" class="home">
    <van-sticky>
      <form action="/">
        <van-search
          v-model="value"
          placeholder="车型名称"
          show-action
          label="保险盒说明"
          @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </form>
    </van-sticky>
    <div class="main">
      <van-tabs
        v-if="!searchItem &&types.length!==0"
        v-model="active"
        color="#4065f4"
        swipe-threshold="3"
      >
        <van-tab
          v-for="(item,index) in types"
          :title="item.fuseVehicleBrand + '汽车'"
          :key="index">
          <div
            class="list"
            v-for="(items,indexs) in item.fuseVehicleTypes"
            :key="indexs"
          >
            <van-tabs
              color="#fff"
              swipe-threshold="2"
              line-width="20%"
              swipeable
              v-if="items.valid"
            >
              <van-tab
                v-for="(itemChild,indexs) in items.fuseVehicleVariants"
                :key="indexs"
                :title="itemChild.fuseVehicleVariantName"
                v-if="itemChild.effectiveDate < time && itemChild.fuseVehicleVariantStatusDictKey === 3"
              >
                <div
                  @click="itemUpdate(itemChild)"
                  v-bind:style="{backgroundImage: `url(${itemChild.imageUrl})`,height: height + 'px',}"
                  class="width">
                  <!--                  v-bind:style="{ width:width+'px' ,height: height + 'px',background:'white'}"-->
                  <!--                  <van-image-->
                  <!--                    :width="width"-->
                  <!--                    :src="itemChild.imageUrl">-->
                  <!--                    <template v-slot:loading>-->
                  <!--                      <van-loading type="spinner" size="20"/>-->
                  <!--                    </template>-->
                  <!--                  </van-image>-->
                </div>
                <div
                  v-if="update" :class="itemChild.show"
                  @click.prevent="itemUpdate(itemChild)">
                  <div
                    v-for="(items,indexsss) in itemChild.fuseBoxes"
                    :key="indexsss"
                    @click.stop="detailPage(itemChild,items)"
                    :class="itemChild.fuseBoxes.length >= 6 ? 'block' : 'blocks'">
                    {{ items }}
                  </div>
                </div>
              </van-tab>
            </van-tabs>
            <div
              v-if="!items.valid && item.fuseVehicleTypes.length === 1">
              <van-empty description="暂无数据"/>
              <!--              <van-empty image="error" description="生效时间还未到"/>-->
            </div>
          </div>
          <div
            v-if="item.fuseVehicleTypes.length === 0"
            class="empty">
            <van-empty description="暂无数据"/>
            <!--            <van-empty image="network" description="信息维护中，请稍后重试"/>-->
          </div>
        </van-tab>
      </van-tabs>
      <div
        v-else-if="searchList.length>0"
        v-for="(itemChild,index) in searchList"
        :key="index"
        class="item">
        <div v-if="!itemChild.valid">
          <van-empty description="暂无数据"/>
        </div>
        <van-tabs
          v-else v-model="itemChild.fuseVehicleTypeName"
          color="#fff"
          swipe-threshold="2"
          line-width="20%"
          swipeable>
          <van-tab
            v-for="(itemChildInfo,index) in itemChild.fuseVehicleVariants"
            :title="itemChildInfo.fuseVehicleVariantName"
            :key="index"
            v-if="itemChildInfo.effectiveDate < time"
          >
            <div @click="itemUpdate(itemChildInfo)"
                 v-bind:style="{backgroundImage: `url(${itemChildInfo.imageUrl})`,height: height + 'px',}"
                 class="width">
              <!--              <van-image-->
              <!--                :src="itemChildInfo.imageUrl">-->
              <!--                <template v-slot:loading>-->
              <!--                  <van-loading type="spinner" size="20"/>-->
              <!--                </template>-->
              <!--              </van-image>-->
            </div>
            <div
              v-if="update"
              :class="itemChildInfo.show"
              @click.prevent="itemUpdate(itemChildInfo)">
              <a
                v-for="(items,indexsss) in itemChildInfo.fuseBoxes"
                :key="indexsss"
                @click.stop="detailPage(itemChildInfo,items)"
                :class="itemChildInfo.fuseBoxes.length>=6?'block':'blocks'"
              >
                {{ items }}
              </a>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div v-else>
        <van-empty description="暂无数据"/>
      </div>
    </div>
  </div>
</template>

<script>

import {formatTimeFromTimestamps, getUrlParams} from '../utils/util';
import {axios} from '../utils/request';
import {scriptFn} from '../utils/getJSON';
import {JSON_URL} from '../configs/base';

export default {
  name: 'Home.vue',
  data() {
    return {
      value: '',
      active: '',
      types: [],
      data: {},
      itemChildInfo: [],
      searchItem: false,
      update: true,
      window: {
        width: document.body.clientWidth
      },
      width: '',
      height: '',
      time: new Date().getTime(),
      searchList: [],
      search: window.location.search,
      str: ''
    };
  },
  watch: {
    value(val) {
      if (!val) {
        this.searchItem = false;
      }
    }
  },
  mounted() {
    this.init();
  },
  created() {
    this.initWindow();
  },
  methods: {
    // 实时获取页面宽度
    initWindow() {
      this.height = (this.window.width - 40) * (1081 / 1752);
      window.onresize = () => {
        return (() => {
          this.window.width = document.body.clientWidth;
          this.height = (this.window.width - 40) * (1081 / 1752);
        })();
      };
      this.width = this.window.width - 40;
    },
    // 初始化
    init() {
      this.str = decodeURIComponent(getUrlParams(this.search).band);
      this.getItem(this.str.slice(1, -1).split(','));
    },
    // 搜索
    onSearch() {
      if (this.value) {
        this.searchItem = true;
        this.searchList = [];
        JSON.parse(JSON.stringify(this.types)).forEach(val => {
          val.fuseVehicleTypes.forEach(vals => {
            if (vals.fuseVehicleTypeName.indexOf(this.value) !== -1) {
              this.searchList.push(vals);
            }
          });
        });
      }
    },
    // 页面刷新
    itemUpdate(item) {
      item.show = item.show === 'car-wrapper' ? 'car' : 'car-wrapper';
      this.update = false;
      this.$nextTick(() => {
        this.update = true;
      });
    },
    // 跳转详情页
    detailPage(item, id) {
      this.$router.push({
        path: '/detail',
        query: {
          id: id,
          path: item.path,
          fuseBoxes: item.fuseBoxes
        }
      });
    },
    getItem(item) {
      const timestamp = new Date().getTime();
      // let url = 'fushjsonfile/vehicle.json';
      let url = JSON_URL + 'vehicle.json' + '?' + timestamp;
      // fetch('//glswdl-ps.test.geely.com/fuseboxjson/vehicle.json').then(data=>data.json()).then(data=>console.log(data));

      // scriptFn();
      // return;
      axios.get(url).then(res => {
        if (item) {
          if (item.indexOf('全部') === -1 && item.indexOf('ndefine') === -1 && item.indexOf('') === -1) {
            item.forEach(val => {
              res.data.forEach(vals => {
                if (val === vals.fuseVehicleBrand) {
                  this.types.push(vals);
                }
              });
            });
            this.types.forEach(val => {
              val.fuseVehicleTypes.forEach(vals => {
                vals.fuseVehicleVariants.forEach(valss => {
                  valss.path = val.fuseVehicleBrand + '_' + vals.fuseVehicleTypeName + '_' + valss.fuseVehicleVariantName;
                  valss.show = 'car';
                  valss.effectiveDate = formatTimeFromTimestamps(valss.effectiveDate);
                  vals.list = 0;
                  if (valss.effectiveDate <= this.time && valss.fuseVehicleVariantStatusDictKey === 3) {
                    vals.list++;
                  }
                  if (vals.list > 0) {
                    vals.valid = true;
                  }
                });
              });
            });
          } else {
            this.checkItem(res.data);
          }
        } else {
          this.checkItem(res.data);
        }
      });
    },
    checkItem(item) {
      this.types = item;
      this.types.forEach(val => {
        val.fuseVehicleTypes.forEach(vals => {
          vals.fuseVehicleVariants.forEach(valss => {
            valss.path = val.fuseVehicleBrand + '_' + vals.fuseVehicleTypeName + '_' + valss.fuseVehicleVariantName;
            valss.show = 'car';
            valss.effectiveDate = formatTimeFromTimestamps(valss.effectiveDate);
            vals.list = 0;
            if (valss.effectiveDate <= this.time && valss.fuseVehicleVariantStatusDictKey === 3) {
              vals.list++;
            }
            if (vals.list > 0) {
              vals.valid = true;
            }
          });
        });
      });
    }
  }
};
</script>
<style lang="less">
.home {
  height: calc(100vh - 54px);

  .van-search {
    background: #4065f4;

    .van-search__action {
      margin-right: 10px;
      background: #fff;
      color: #4065f4;
      border-radius: 0px 5px 5px 0px;
      font-weight: 600;
    }

    .van-search__content {
      padding-left: 0;
      background: #4065f4;

      .van-search__label {
        color: #fff;
        font-weight: 600;
        padding: 0 20px 0 0;
      }

      .van-cell {
        background: #fff;
        border-radius: 5px 0 0 5px;

        .van-field__left-icon {
          margin: 0 5px;
        }
      }

    }
  }

  .main {
    width: 100%;
    min-height: calc(100vh - 54px - 20px);
    background: rgba(0, 0, 0, .2);
    padding-bottom: 20px;

    .empty {
      height: calc(100vh - 50px);
    }

    .van-tabs__wrap {
      .van-tabs__nav {
        .van-tab {
          font-size: 18px;
        }

        .van-tab--active {
          color: #323233;
          font-weight: 700;
        }
      }
    }

    .van-tabs__content {
      height: 100%;
      padding: 10px 20px 0px 20px;

      .list {
        width: 100%;

        .van-tabs__content {
          padding: 0;

          .van-tab__pane {
            position: relative;
            width: 100%;
            display: flex;
            text-align: center;


            //.van-image {
            //  width: 100%;
            //  height: 100%;
            //}

            .car-wrapper {
              position: absolute;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              color: #fff;
              background: rgba(0, 0, 0, .8);
              z-index: 1;

              .block {
                font-size: 14px;
                font-weight: 600;
                margin: 2px auto;
                border-bottom: 2px solid #fff;
                padding-top: 5px;
              }

              .blocks {
                padding: 5px 0 0 0;
                font-size: 14px;
                font-weight: 600;
                margin: 8px auto;
                border-bottom: 2px solid #fff;
              }
            }

            .caption {
              top: 0;
              transition: all .9s ease-in-out;
            }

            .car {
              display: none;
            }
          }
        }

        .van-tabs {

          .van-tabs__wrap {

            .van-tabs__nav {
              background: #969799;

              .van-tab {
                padding: 0;
                width: 50%;
                font-size: 14px;
                color: #fff;

                .van-tab__text {
                }
              }
            }
          }

          .van-tabs__content {
          }
        }
      }
    }

    .item {
      padding: 0px 20px;
      background: rgba(0, 0, 0, .1);

      .van-tabs__content {
        padding: 0;

        .van-tab__pane {
          position: relative;
          width: 100%;
          display: flex;
          text-align: center;

          //.van-image {
          //  width: 100%;
          //  height: 100%;
          //}

          .car-wrapper {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #fff;
            background: rgba(0, 0, 0, .8);
            z-index: 1;

            .block {
              font-size: 14px;
              font-weight: 600;
              margin: 2px auto;
              border-bottom: 2px solid #fff;
              padding-top: 5px;
            }

            .blocks {
              padding: 5px 0 0 0;
              font-size: 14px;
              font-weight: 600;
              margin: 8px auto;
              border-bottom: 2px solid #fff;
            }
          }

          .car {
            display: none;
          }
        }
      }

      .van-tabs {


        .van-tabs__wrap {

          .van-tabs__nav {
            background: #969799;

            .van-tab {
              padding: 0;
              width: 50%;
              font-size: 14px;
              color: #fff;

              .van-tab__text {
              }
            }
          }
        }

        .van-tabs__content {
        }
      }
    }

    .item:nth-child(1) {
      padding-top: 10px;
    }
  }

  .van-empty {
    height: calc(100vh - 54px - 55px);
  }
}

.width {
  width: 100%;
  background-color: white;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue